module.exports = __webpack_public_path__ + "static/img/applicableScene2.e593a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene2.png
// module id = 7q/T
// module chunks = 0